import { z } from 'zod';
export const RETROBRIGHT_STATUSES = ['planned', 'in_progress', 'curing', 'completed', 'cancelled'];
export const sessionSchema = z.object({
    startTime: z.string(),
    endTime: z.string().nullable().optional(),
    durationMinutes: z.number().min(0).optional(),
    notes: z.string().max(500).optional().default(''),
});
export const createRetroBrightSchema = z.object({
    name: z.string().min(1).max(255),
    targetHours: z.number().min(0).max(1000).default(0),
    notes: z.string().max(2000).optional().default(''),
});
export const updateRetroBrightSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    status: z.enum(RETROBRIGHT_STATUSES).optional(),
    targetHours: z.number().min(0).max(1000).optional(),
    notes: z.string().max(2000).optional(),
});
//# sourceMappingURL=retrobright.js.map